import { render, staticRenderFns } from "./AppointmentHistory.vue?vue&type=template&id=1edec54d"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js"
import style0 from "./AppointmentHistory.vue?vue&type=style&index=0&id=1edec54d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports